import { useState } from 'react';

export const useDropdownMenu = () => {
  const [showMenu, setShowMenu] = useState<boolean>(false);
  const toggleMenu = (value?: boolean) => {
    if (value !== undefined) {
      setShowMenu(value);
      return;
    }

    setShowMenu(!showMenu);
  };
  return { showMenu, toggleMenu };
};
